export default "__VITE_ASSET__88c1a415__"